import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-client-button',
  templateUrl: './add-client-button.component.html',
  styleUrls: ['./add-client-button.component.css']
})
export class AddClientButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
